import { render, staticRenderFns } from "./Wellness.vue?vue&type=template&id=1bf1ac12&"
import script from "./Wellness.vue?vue&type=script&lang=js&"
export * from "./Wellness.vue?vue&type=script&lang=js&"
import style0 from "./Wellness.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports